import { render, staticRenderFns } from "./InspectDetailQuery.vue?vue&type=template&id=4c07dfaf"
import script from "./InspectDetailQuery.vue?vue&type=script&lang=js"
export * from "./InspectDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports